import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { fetchWelcomeFlowData } from '../../api'

export const requestWelcomeFlowData = createAsyncThunk(
  'welcomeFlow/requestWelcomeFlowData',
  fetchWelcomeFlowData
)
